import Toggleable from "./Toggleable.mjs";

export default {

    mixins: [Toggleable],

    props: {
        duration: {
            type: [Number, String, Boolean],
            default: 4500
        }
    },

    data() {
        return {
            toggleTimeout: null
        }
    },

    computed: {
        autoToggleEnabled() {
            return this.duration && this.duration > 0
        }
    },

    watch: {
        isActive(active) {
            if (active) {
                this.activateToggleTimeout();
            }
        }
    },

    beforeUnmount() {
        if (this.toggleTimeout) {
            clearTimeout(this.toggleTimeout);
        }
    },

    methods: {
        activateToggleTimeout() {
            if (!this.autoToggleEnabled) {
                return;
            }
            this.toggleTimeout = setTimeout(() => {
                this.isActive = false;
            }, this.duration);
        }
    }
}
